import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom-v5-compat';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';

import { useIsOnReturnsAdvancedSearchView } from '../../../advanced-search/hooks';
import ReturnsEditColumnsButtonContainer from '../../../components/edit-columns-button/containers/returns-grid-container';
import ErrorBoundary from '../../../components/error-boundary';
import { V6RouteReturnModalLoaderModalWrapper } from '../../../components/modals/return-details-modal/v6-return-modal-loader';
import ReturnPageHeader from '../../../components/returns-page-header/index';
import ReturnsStatusTabs from '../../../components/returns-status-tabs';
import { ReturnsFilterBarContainer } from '../../../containers/returns-filter-bar-container';
import { ReturnsGridContainer } from '../../../containers/returns-grid-container';
import { ReturnsGridPagingControlContainer } from '../../../containers/returns-grid-paging-control-container';
import { FiltersContextProvider } from '../../../filters/context';
import {
  FULFILLMENTS_RETURNS_RETURN_PATH,
  FULFILLMENTS_RETURNS_ENHANCED_RETURN_PATH,
  FULFILLMENTS_RETURNS_STATUS_ENHANCED_RETURN_PATH,
} from '../../../routes/constants';
import Global from '../../../store/global-selectors';
import * as NavActions from '../../../store/returns/nav/returns.nav.actions';
import gridPageStyle from '../../grid-page.module.less';

const FulfillmentsReturnsPage = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isLoading = useSelector(Global.selectReturnsGridIsLoading);

  const getFulfillmentsReturnsStatus = (currentPath) => {
    const segments = currentPath.split('/');
    const idx = segments.indexOf('returns');

    if (idx === -1 || idx === segments.length - 1) {
      return 'outstanding';
    }

    return segments[idx + 1] || 'outstanding';
  };

  const selectedTab = getFulfillmentsReturnsStatus(pathname);

  useEffect(() => {
    dispatch(NavActions.changeView(selectedTab, false));
    dispatch(NavActions.returnsViewsChanged());
  }, [selectedTab, dispatch]);

  const isOnAdvancedSearch = useIsOnReturnsAdvancedSearchView();

  return (
    <FiltersContextProvider>
      <FlexRow className={gridPageStyle['grid-header']}>
        <ReturnPageHeader />
        <FlexColumn className={gridPageStyle['edit-columns-button-container']}>
          <ReturnsEditColumnsButtonContainer />
        </FlexColumn>
      </FlexRow>
      <FlexColumn className={gridPageStyle['edit-grid-wrap']}>
        <FlexColumn>{!isOnAdvancedSearch && <ReturnsStatusTabs />}</FlexColumn>
        <FlexColumn className={gridPageStyle['grid-filter-wrap']}>{!isOnAdvancedSearch && <ReturnsFilterBarContainer />}</FlexColumn>
      </FlexColumn>
      <FlexColumn className={gridPageStyle['grid-content']}>
        {isLoading ? <LoadingIndicator /> : null}
        {!isLoading && (
          <FlexColumn className={classnames(gridPageStyle['grid-and-footer'], gridPageStyle['no-sidebar'])}>
            <FlexColumn className={gridPageStyle.grid}>
              <ErrorBoundary errorMessageId='returnsGrid'>
                <ReturnsGridContainer />
              </ErrorBoundary>
            </FlexColumn>
            <ReturnsGridPagingControlContainer containerClassName={gridPageStyle['paging-footer']} />
          </FlexColumn>
        )}
      </FlexColumn>
      <Routes>
        <Route element={<V6RouteReturnModalLoaderModalWrapper />} path={FULFILLMENTS_RETURNS_RETURN_PATH} />
        <Route element={<V6RouteReturnModalLoaderModalWrapper />} path={FULFILLMENTS_RETURNS_ENHANCED_RETURN_PATH} />
        <Route element={<V6RouteReturnModalLoaderModalWrapper />} path={FULFILLMENTS_RETURNS_STATUS_ENHANCED_RETURN_PATH} />
      </Routes>
    </FiltersContextProvider>
  );
};

export default FulfillmentsReturnsPage;
